import {
  initialState,
  Actions,
  State,
  CHANGE_USER_PASSWORD,
  CHANGE_USER_PASSWORD_SUCCESS,
  CHANGE_USER_PASSWORD_ERROR,
  RESET_CHANGE_USER_PASSWORD
} from "../../types/user/change-user-password";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case CHANGE_USER_PASSWORD:
      return {
        ...state,
        states: {
          success: false,
          loading: true,
          error: false,
        },
      };
    case CHANGE_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        states: {
          success: true,
          loading: false,
          error: false,
        },
      };
    case CHANGE_USER_PASSWORD_ERROR:
      return {
        ...state,
        states: {
          success: false,
          loading: false,
          error: true,
        },
      };
    case RESET_CHANGE_USER_PASSWORD:
      return initialState
    default:
      return state;
  }
};

export default reducers;
